import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getAllLiabilityType } from "../../../../apis/actions/recipient.actions";
import Inputs from "../../../../biblio/Inputs/Inputs";
import Selects from "../../../../biblio/Selects/Selects";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";

interface LiabilityInfoFormProps {
  form: any;
}

const LiabilityInfo = ({ form }: LiabilityInfoFormProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { liabilityTypes } = useSelector((state: RootState) => state.recipient);
  const [liabilityRows, setLiabilityRows] = useState<any[]>([
    { key: Date.now(), liability_type_id: undefined, number: 1 },
  ]);

  useEffect(() => {
    dispatch(getAllLiabilityType());
  }, [dispatch]);

  const addNewRow = () => {
    setLiabilityRows([
      ...liabilityRows,
      { key: Date.now(), liability_type_id: undefined, number: 1 },
    ]);
  };

  const handleRowChange = (index: number, field: string, value: any) => {
    const updated = [...liabilityRows];
    updated[index][field] = value;
    setLiabilityRows(updated);
    form.setFieldsValue({
      liability_ids: updated.map(({ key, ...rest }) => rest),
    });
  };
  const deleteRow = (key: number) => {
    const filtered = liabilityRows.filter((row) => row.key !== key);
    setLiabilityRows(filtered);
    form.setFieldsValue({
      liability_ids: filtered.map(({ key, ...rest }) => rest),
    });
  };
  const columns = [
    {
      width: "30%",
      title: "الإلتزام",
      dataIndex: "liability_type_id",
      render: (_: any, record: any, index: number) => (
        <Form.Item
          name={["liability_ids", index, "liability_type_id"]}
          rules={[{ required: true, message: "الرجاء تعبئة الحقل" }]}
          style={{ marginBottom: 0 }}
        >
          <Selects
            allowClear={false}
            value={record.liability_type_id}
            onChange={(selected: any) =>
              handleRowChange(index, "liability_type_id", selected.key)
            }
            options={liabilityTypes}
          />
        </Form.Item>
      ),
    },
    {
      width: "20%",
      title: "العدد",
      dataIndex: "number",
      render: (_: any, record: any, index: number) => (
        <Form.Item
          name={["liability_ids", index, "number"]}
          rules={[
            {
              validator: (_, value) => {
                if (value === undefined || value === "" || isNaN(value)) {
                  return Promise.reject(new Error("الرجاء تعبئة الحقل"));
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <Inputs
            maxLength={11}
            type="tel"
            value={record.number}
            onChange={(e) => {
              const value = e.target.value;
              // Only update if the value is a number or empty
              if (value === "" || !isNaN(Number(value))) {
                handleRowChange(
                  index,
                  "number",
                  value === "" ? undefined : parseInt(value),
                );
              }
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "المبلغ",
      render: (_: any, record: any) => {
        const typeObj = liabilityTypes.find(
          (t: any) =>
            t.id === record.liability_type_id ||
            t.name === record.liability_type_id,
        );
        const amount = typeObj ? typeObj.amount : 0;
        return (
          <span>{Number.isInteger(amount) ? amount : amount.toFixed(2)}</span>
        );
      },
    },
    {
      title: "المبلغ الجملي",
      render: (_: any, record: any) => {
        const typeObj = liabilityTypes.find(
          (t: any) =>
            t.id === record.liability_type_id ||
            t.name === record.liability_type_id,
        );
        const amount = typeObj ? typeObj.amount : 0;
        const numberValue = record.number || 0;
        const total = amount * numberValue;
        return (
          <span>{Number.isInteger(total) ? total : total.toFixed(2)}</span>
        );
      },
    },
    {
      title: (
        <PrimaryButton
          icon={<PlusCircleOutlined />}
          onClick={addNewRow}
          title=""
        />
      ),
      render: (_: any, record: any) => (
        <DeleteOutlined
          onClick={() => deleteRow(record.key)}
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>الإلتزامات الجّارية</span>
      </div>

      <Form.Item name="liability_ids" style={{ display: "none" }}>
        <input type="hidden" />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col xxl={18} xl={18} lg={18} md={24} sm={24} xs={24}>
          <Table
            className="takaful--table"
            dataSource={liabilityRows}
            columns={columns}
            pagination={false}
            rowKey="key"
            locale={{
              emptyText: (
                <span className="takaful--empty-text-table">
                  لا توجد بيانات
                </span>
              ),
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default LiabilityInfo;
